<template>
  <div class="exercise-box pt60 base-bg">
    <div class="tag-filter-container clearfix">
      <!--            <div class="profile-logo">-->
      <!--                <img src="https://tlearning.cloud.tencent.com/widget/img/upload-img.png">-->
      <!--            </div>-->
      <div class="tag-filter-wrap">
        <div class="tag-filter-inner">
          <div class="tag-filter-item" v-if="qb_filteroption[0]">
            <div class="title-txt">{{qb_filteroption[0].name}}</div>
            <div class="tag-wrap">
              <a class="selection_button_a" :class="curProfession=='全部' ? 'selected' : ''" href="javascript:;"
                 @click="clickProfession({name:'全部'})">全部</a>
              <a class="selection_button_a"
                 href="javascript:;"
                 v-for="(item,index) in qb_filteroption[0].options"
                 :key="index"
                 :class="curProfession==item.name ? 'selected' : ''"
                 @click="clickProfession(item)"
              >
                {{ item.name }}
              </a>
            </div>
          </div>
          <div class="tag-filter-item" v-if="qb_filteroption[1]">
            <div class="title-txt">{{qb_filteroption[1].name}}</div>
            <div class="tag-wrap">
              <a class="selection_button_a" :class="curDifficulty=='全部' ? 'selected' : ''" href="javascript:;"
                 @click="clickDifficulty({name:'全部'})">全部</a>
              <a class="selection_button_a"
                 href="javascript:;"
                 v-for="(item,index) in qb_filteroption[1].options"
                 :key="index"
                 :class="curDifficulty==item.name ? 'selected' : ''"
                 @click="clickDifficulty(item)"
              >
                {{ item.name }}
              </a>
            </div>
        </div>
          <div class="tag-filter-item" v-if="qb_filteroption[2]">
            <div class="title-txt">{{qb_filteroption[2].name}}</div>
            <div class="tag-wrap">
              <a class="selection_button_a" :class="tpaper_status=='全部' ? 'selected' : ''" href="javascript:;"
                 @click="clicktPaperStatus({name:'全部'})">全部</a>
              <a class="selection_button_a"
                 href="javascript:;"
                 v-for="(item,index) in qb_filteroption[2].options"
                 :key="index"
                 :class="tpaper_status==item.name ? 'selected' : ''"
                 @click="clicktPaperStatus(item)"
              >
                {{ item.name }}
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="course-wrap">
      <div class="course-hd">
        <div class="cols" v-if="all_qbcenter.body" >
          <h3 style="display: inline-block; vertical-align: middle;margin-left: 12px">
            {{all_qbcenter.body.length}}套相关习题</h3>
        </div>
      </div>
      <div class="courses_order_div">
        <div class="left_order_button_div">
          <!--                    <div class="base_order_div order_div">-->
          <!--                        <a class="selection_button_a"-->
          <!--                           href="javascript:;"-->
          <!--                           v-for="name in ['综合', '最新', '最热']"-->
          <!--                           :key="name"-->
          <!--                           :class="current_base_order==name ? 'selected' : ''"-->
          <!--                        >-->
          <!--                            {{ name }}-->
          <!--                        </a>-->
          <!--                    </div>-->
          <div class="order_div" style="margin-left:12px ">
            <Input search placeholder="请输入试卷名称或关键词" style="width: 200px" @on-search="tpaperSearch"/>
          </div>
        </div>
        <div class="course-inner">
          <div v-show="all_qbcenter.body" style="margin-top: 20px">
            <card
            v-for="(list, index) in all_qbcenter.body"
            :key="index"
            :data="list"
            ></card>
            <div class="page-box" v-if="all_qbcenter.page && all_qbcenter.body.length>0">
              <Page
              :total="all_qbcenter.page.count"
              :page-size="all_qbcenter.page.page_size"
              :current="all_qbcenter.page.current"
              @on-change="currentPage"
              show-total
              />
            </div>
          </div>
          <div v-if="all_qbcenter.body">
            <emptyWrap v-show="all_qbcenter.body.length == 0" :title="'未找到匹配条件的习题'" :border="true"></emptyWrap>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

  import {mapActions, mapGetters, mapState} from "vuex";
  import emptyWrap from '@/components/common_components/empty_wrap/empty_wrap.vue'
  import Card from './common/card'

  export default {
    name: "exercise",
    components: {
      emptyWrap,
      Card
    },
    data() {
      return {
        curProfession: '全部',
        curDifficulty: '全部',
        tpaper_status:'全部',
        direction:null,
        complexity:null,
        tpaper_status_id:null,
        name:null,
        page_num: 1,
        page_size: 24,
      }
    },
    computed: {
      ...mapState({
        all_qbcenter: state => state.teachingScore.all_qbcenter,
        qb_filteroption:state => state.teachingScore.qb_filteroption
      }),
    },
    methods: {
      ...mapActions({
        getQbCenter: 'teachingScore/getQbCenter',
        getQbFilterOption:'teachingScore/getQbFilterOption'
      }),
      clickProfession(item) {
        this.curProfession = item.name
        this.direction = item.id
        this.initQbCenter()
      },
      clickDifficulty(item) {
        this.curDifficulty = item.name
        this.complexity = item.id
        this.initQbCenter()
      },
      clicktPaperStatus(item) {
        this.tpaper_status = item.name
        this.tpaper_status_id = item.id
        this.initQbCenter()
      },
      tpaperSearch(val) {
        this.name = val
        this.initQbCenter()
      },
      currentPage(page) {
        this.page_num = page
        this.initQbCenter()
      },
      initQbCenter() {
        let _this = this
        this.getQbCenter({
          page_num: _this.page_num,
          page_size: _this.page_size,
          direction: _this.direction,
          complexity: _this.complexity,
          tpaper_status: _this.tpaper_status_id,
          name:_this.name
        })
      }
    },
    mounted() {
      this.initQbCenter()
      this.getQbFilterOption()
    },
  }
</script>

<style scoped lang="less">
  .exercise-box {
    padding-bottom: 30px;

    .page-box {
      text-align: center;
    }
  }
</style>
